import { useState } from "react";

import LeadInventoryTable from "../components/lead-inventory/construction_site/sidebar-table.jsx";
import { useLeadInventoryYours } from "@/api/lead/useLeadInventoryYours.js";

export default function ComponentConstructionSite(){
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [filters, setFilters] = useState(null);
    const [searchName, setSearchName] = useState("");
    const [selectedPipelineStage, setSelectedPipelineStage] = useState(null);

    const [isOpen, setIsOpen] = useState(false);

    const {data, totalPages} = useLeadInventoryYours(page, pageSize, selectedStatus, filters, selectedPipelineStage, searchName)
    return(

        <div className="p-4">
            <div className="py-8">
                <LeadInventoryTable data={data} totalPages={totalPages} />
            </div>
        </div>
    )
}